// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/delete-filled.svg';

export const DeleteFilled = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
